import { BillHoursSourceTypeDTO } from '@/modules/finance/bills/types/dto/response/bill-hours-source-type.dto';
import { BillHoursSourceResponse } from '@/modules/finance/bills/types/dto/response/bill-hours-source.response';
import { BillTimeOffSourceTypeDTO } from '@/modules/finance/bills/types/dto/response/bill-time-off-source-type.dto';
import { BillTimeOffSourceResponse } from '@/modules/finance/bills/types/dto/response/bill-time-off-source.response';

import {
  BillHoursSource,
  BillHoursSourceType,
  BillTimeOffSource,
  BillTimeOffSourceType,
} from '../types';

/**
 * Maps bill hours source type from DTO to domain enum
 */
export const mapBillHoursSourceTypeFromDTO = (dto: BillHoursSourceTypeDTO): BillHoursSourceType => {
  switch (dto) {
    case BillHoursSourceTypeDTO.TRACKED:
      return BillHoursSourceType.TRACKED;
    case BillHoursSourceTypeDTO.BOOKED:
      return BillHoursSourceType.BOOKED;
    case BillHoursSourceTypeDTO.CAPACITY:
      return BillHoursSourceType.CAPACITY;
    case BillHoursSourceTypeDTO.APPROVED:
      return BillHoursSourceType.APPROVED;
    case BillHoursSourceTypeDTO.TIME_OFF:
      return BillHoursSourceType.TIME_OFF;
    default:
      return BillHoursSourceType.TRACKED;
  }
};

/**
 * Maps bill hours source DTO to bill hours source domain model
 */
export const mapBillHoursSourcesFromDTO = (
  sources: BillHoursSourceResponse[]
): BillHoursSource[] => {
  return sources.map(source => ({
    sourceType: mapBillHoursSourceTypeFromDTO(source.sourceType),
    hours: parseFloat(source.hours),
    amount: parseFloat(source.amount),
    currencyCode: source.currencyCode,
    averageRate: parseFloat(source.averageRate),
  }));
};

/**
 * Maps a time-off approval-status source type from DTO to the domain enum.
 */
export const mapBillTimeOffSourceTypeFromDTO = (
  dto: BillTimeOffSourceTypeDTO
): BillTimeOffSourceType => {
  switch (dto) {
    case BillTimeOffSourceTypeDTO.APPROVED:
      return BillTimeOffSourceType.APPROVED;
    case BillTimeOffSourceTypeDTO.PENDING:
      return BillTimeOffSourceType.PENDING;
    case BillTimeOffSourceTypeDTO.APPROVED_AND_PENDING:
      return BillTimeOffSourceType.APPROVED_AND_PENDING;
    default:
      return BillTimeOffSourceType.APPROVED;
  }
};

export const mapBillTimeOffSourcesFromDTO = (
  sources: BillTimeOffSourceResponse[] = []
): BillTimeOffSource[] =>
  sources.map(source => ({
    sourceType: mapBillTimeOffSourceTypeFromDTO(source.sourceType),
    hours: parseFloat(source.hours),
    averageRate: parseFloat(source.averageRate),
    amount: parseFloat(source.amount),
  }));
